import { APIResponse, useAppQuery } from '@alluradirect/react';

interface Args {
  enabled?: boolean;
}

export const useResortsQuery = ({ enabled = true }: Args = { enabled: true }) => {
  return useAppQuery<APIResponse<{ RESORTS: Resort[] }>>({
    endpoint: '/RESTAUTH/location/?categories=resorts',
    enabled,
  });
};

interface Resort {
  ID: number;
  NAME: string;
  REGION_ID: number;
}
